import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { TpslInfo as TimeTriggerTpslProps, tpslModalBunja } from './tpsl-modal-bunja';

export type { TimeTriggerTpslProps };

/**
 * @deprecated
 * should remove after supporting new time trigger
 * 현재는 해당 모달을 쓰는 케이스는 time trigger 밖에 없다.
 * 이후에 time trigger modal이 개편되면 useTpslModalOverlay를 사용할 것
 */
export function useTimeTriggerTpslModal() {
  const { tpslInfoAtom, isShowAtom, openTpslModal, closeTpslModal } = useBunja(tpslModalBunja);
  const isShow = useAtomValue(isShowAtom);
  const tpSlInfo = useAtomValue(tpslInfoAtom);

  return {
    isShow,
    tpSlInfo,
    onOpenTimeTriggerTpslModal: openTpslModal,
    onCloseTimeTriggerTpslModal: closeTpslModal,
  };
}
